import { createFunnelPageConfig, LandingPageKind, templateSection, type LandingTemplate } from "../../template";

/**
 * "Hollywood po Bikini": the offer of the full Program Hollywood for participants of the
 * Bikini challenge (`/oferta/hollywood-bikini-continue/*`). The copy of every section is
 * exported, so the section definitions use it as their defaults.
 */

const checkoutAnchor = "checkout";

export const bikiniContinueLandingProps = {
  effects: { stepSlug: "landing", facebookPixel: true },
  header: {
    menuItems: [
      { label: "Metamorfozy", href: "#transformations" },
      { label: "Polecenia", href: "#reviews" },
      { label: "Dlaczego to działa", href: "#dlaczego" },
      { label: "Program Hollywood", href: "#program" },
      { label: "Warunki uczestniczki", href: "#warunki" },
      { label: "Przejdź do checkoutu", href: `#${checkoutAnchor}` },
    ],
    ctaLabel: "Aktywuj rabat 450 zł",
    ctaHref: `#${checkoutAnchor}`,
  },
  hero: {
    badge: "Dostęp tylko dla uczestniczek Bikini",
    title: "Zaczęłaś proces metamorfozy.<br />Teraz zdecyduj, czy go dokończysz.",
    subtitle:
      "Dołączyłaś do wyzwania Bikini. Zrobiłaś pierwszy krok. 💛<br />I właśnie dlatego masz dziś dostęp do warunków, których nie zobaczą inne kobiety.",
    ctaLabel: "👉 Przejdź do Programu Hollywood",
    scrollTargetId: checkoutAnchor,
    videoBadge: "Obejrzyj wideo przed decyzją",
    wistiaVideoId: "ju4rv7b3kv",
    stats: [
      { value: "18 000+", label: "metamorfoz" },
      { value: "100", label: "miejsc miesięcznie" },
      { value: "od 2020", label: "sprawdzony model" },
    ],
    showTimer: true,
  },
  transformations: {},
  reviews: { ctaLabel: "👉 Chcę kontynuować proces", scrollTargetId: checkoutAnchor },
  why: {
    title: "✨ Bikini miało Ci coś udowodnić.",
    intro: "Nie to, że możesz schudnąć w 6 tygodni. Ale to, że:",
    items: ["potrafisz działać,", "możesz wrócić do regularności,", "nie zrezygnowałaś z siebie."],
    outro:
      "To był początek.<br />Ale prawda jest taka: 6 tygodni wystarczy, żeby zacząć.<br />Nie wystarczy, żeby zmienić sylwetkę na stałe.",
    problemTitle: "🤍 Dlaczego kolejne wyzwanie nie rozwiąże problemu?",
    problemText:
      "Gdyby krótkie wyzwania działały długoterminowo, już dawno miałabyś swoją wymarzoną sylwetkę.<br />To nie kwestia silnej woli. To kwestia zbyt krótkiego procesu.",
    needsIntro: "Twoje ciało potrzebuje:",
    needs: [
      "💪 ćwiczeń dopasowanych do Twojej sylwetki",
      "🥗 regularnie zmienianej diety",
      "🍑 budowania tkanki mięśniowej",
      "♀️ stabilizacji metabolizmu",
    ],
    needsOutro: "Gdy połączymy te elementy w całość, możesz zobaczyć takie efekty jak nasze podopieczne.",
    durationTitle: "Właśnie dlatego Program Hollywood trwa 6 miesięcy.",
    durationIntro: "Bo tyle potrzeba, aby:",
    durationItems: ["zobaczyć realną zmianę,", "utrzymać ją,", "przestać zaczynać „od poniedziałku”."],
    image: "/assets/group-traning.webp",
    imageAlt: "Uczestniczki treningu Programu Hollywood",
  },
  middleCta: { label: "👉 Chcę kontynuować proces", source: "middle", scrollTargetId: checkoutAnchor },
  program: {
    title: "👑 Program Hollywood to system, nie wyzwanie",
    stats: [
      "✔ 18 000+ przeprowadzonych metamorfoz",
      "✔ 100 nowych kobiet miesięcznie rozpoczyna proces",
      "✔ Średni czas współpracy: 9 miesięcy",
    ],
    text: "To nie chwilowa moda. To powtarzalny, sprawdzony model istniejący od 2020 roku.",
    benefitsTitle: "Co dostajesz w Programie Hollywood?",
    benefits: [
      "💛 Dieta do przygotowania w 20 min dziennie",
      "💛 Trening modelujący mięśnie w domu, nie na siłowni",
      "💛 Kontakt telefoniczny i chatowy z dietetykiem",
      "💛 Dostęp do wszystkich VIP funkcji w aplikacji mobilnej",
      "💛 Wsparcie innych uczestniczek Programu Hollywood",
    ],
    closing:
      "Program Hollywood to idealne rozwiązanie dla kobiet, które nie chcą marnować czasu na siłownię ani gotowanie 6 posiłków dziennie.",
    image: "/assets/form/trenerzy_1.webp",
    imageAlt: "Aplikacja mobilna Programu Hollywood na tablecie",
  },
  comparison: {
    title: "Spójrzmy realistycznie",
    outsideEyebrow: "Poza programem",
    outsideTitle: "Trening personalny + dietetyk",
    outsideRows: [
      { label: "Trening personalny (3x tygodniowo)", price: "1 800 zł / mies." },
      { label: "Dietetyk kliniczny (2 konsultacje)", price: "600 zł / mies." },
    ],
    outsideTotal: "Łącznie: 2 400 zł / miesiąc",
    outsideTotalNote: "+ około 32h miesięcznie na dojazdy i organizację.",
    programEyebrow: "Program Hollywood",
    programPrice: "622 zł / miesiąc",
    programItems: [
      "Trening i dieta w jednej aplikacji.",
      "Kontakt z dietetykiem bez dodatkowych opłat.",
      "Bez marnowania czasu na dojazdy i chaos w planie.",
    ],
    savingsTitle: "Oszczędzasz 1 778 zł miesięcznie",
    savingsNote: "i zyskujesz prosty, prowadzony krok po kroku proces.",
    appTitle: "Wszystko masz pod ręką w aplikacji.",
    appText:
      "Plan diety, treningi i kontakt z dietetykiem - bez chaosu, bez szukania plików.<br />Jedno miejsce, jedno prowadzenie, jeden cel.",
    appScreens: [
      { image: "/assets/app/app_2.webp", alt: "Podgląd planu i postępów w aplikacji Hollywood" },
      { image: "/assets/app/app_1.webp", alt: "Podgląd treningów w aplikacji Hollywood" },
      { image: "/assets/app/app_3.webp", alt: "Podgląd dziennika posiłków w aplikacji Hollywood" },
    ],
  },
  conditions: {
    title: "Warunki uczestniczki Bikini",
    standardLabel: "Standardowa cena",
    standardPrice: "4 182 zł",
    standardNote: "6 × 697 zł",
    discountLabel: "Rabat uczestniczki Bikini",
    discountValue: "-450 zł",
    discountNote: "zwrot inwestycji z wyzwania",
    yourPriceLabel: "Twoja cena",
    yourPrice: "3 732 zł",
    yourPriceNote: "6 rat po 622 zł",
    intro: "Jako uczestniczka wyzwania aktywujesz warunki specjalne, których nie zobaczą inne kobiety.",
    items: [
      "Twoja inwestycja 147 zł wraca do Ciebie w potrojonej wartości.",
      "Otrzymujesz 450 zł rabatu na cały program Hollywood.",
      "Raty spadają z 697 zł do 622 zł miesięcznie.",
    ],
    highlightTitle: "👉 6 rat po 622 zł miesięcznie",
    highlightText: "Zamiast 697 zł. To 75 zł mniej każdego miesiąca.",
    note: "Warunki te obowiązują wyłącznie w trakcie Twojego aktywnego wyzwania.",
    ctaLabel: "👉 Aktywuję warunki uczestniczki",
    scrollTargetId: checkoutAnchor,
  },
  guarantee: {
    title: "Gwarancja Metamorfozy Hollywood",
    ifLabel: "Jeśli:",
    conditions: ["będziesz realizować zalecenia dietetyka", "będziesz wykonywać treningi"],
    text: "i nie zobaczysz realnej zmiany sylwetki - prowadzimy Cię dalej bez dodatkowych opłat, aż efekt będzie widoczny.",
    motto: "Twój sukces = nasz sukces.",
    boxTitle: "🔒 Warunek gwarancji",
    boxText:
      "Realizujesz zalecenia i treningi regularnie, utrzymujesz kontakt z dietetykiem, a my odpowiadamy za efekt procesu i prowadzimy Cię do widocznej zmiany.",
    optionsTitle: "Masz teraz 2 możliwości:",
    option1Badge: "Opcja 1",
    option1Title: "Kolejne wyzwanie.",
    option1Text: "Kolejny start i ryzyko powrotu do punktu wyjścia.",
    option2Badge: "Opcja 2",
    option2Title: "Program Hollywood.",
    option2Items: ["Wyraźnie zmieniona sylwetka.", "Większa pewność siebie.", "Większa ochota do życia."],
    option2Note: "To jest decyzja, która domyka proces.",
    closing: "Różnica to decyzja podjęta dziś.",
  },
  finalCta: {
    badge: "Rabat 450 zł dla uczestniczki Bikini",
    title: "💛 Chcę przejść do Programu Hollywood",
    subtitle: "Aktywuj rabat 450 zł i rozpocznij pełną metamorfozę.",
    priceLine: "6 rat po <strong>622 zł miesięcznie</strong> zamiast 697 zł.",
    ctaLabel: "💛 Przechodzę do Programu Hollywood",
    href: "",
  },
  footer: {},
};

export const bikiniContinueCheckoutProps = {
  intro: {
    eyebrow: "Krok 2",
    title: "👑 To Twój ostatni krok przed rozpoczęciem ostatecznej Metamorfozy Hollywood.",
    subtitle: "Jako uczestniczka wyzwania Bikini aktywujesz warunki specjalne.",
  },
  priceSummary: {
    title: "Program Hollywood - 6 miesięcy",
    rows: [
      { label: "Standardowa cena:", value: "6 × 697 zł = 4 182 zł", emphasized: false },
      { label: "Nagroda uczestniczki wyzwania:", value: "450 zł", emphasized: false },
      { label: "Twoja cena:", value: "3,732 zł", emphasized: true },
    ],
    highlightTitle: "👉 622 zł miesięcznie przez 6 miesięcy",
    highlightText: "Lub jednorazowo 3,523 zł (taniej o dodatkowe 200 zł)",
  },
  benefits: {
    title: "🔥 Co dokładnie otrzymujesz",
    intro: "W cenie otrzymujesz:",
    items: [
      "✔ Indywidualną opiekę dietetyka",
      "✔ Trening dopasowany do typu sylwetki",
      "✔ Prostą dietę (20 min dziennie)",
      "✔ Dostęp do VIP grupy uczestniczek Hollywood",
      "✔ Autorską aplikację",
      "✔ Gwarancję transformacji",
    ],
  },
  guarantee: {
    title: "🔥 🔒 Gwarancja Metamorfozy",
    text: "Jeśli realizujesz minimum 90% zaleceń i nie zobaczysz realnej zmiany sylwetki - prowadzimy Cię dalej bez dodatkowych opłat, aż efekt będzie widoczny.",
    note: "💛 Zachowujesz również 14-dniowe prawo odstąpienia od umowy.",
  },
  payment: {
    title: "🔥 Dane do płatności",
    ctaText: "👉 Rozpoczynam Program Hollywood",
    securityNote: "Bezpieczne płatności SSL",
    costsNote: "Brak ukrytych kosztów",
  },
  faq: {
    title: "🔥 Mini FAQ",
    items: [
      {
        question: "❓ Co dokładnie kupuję i jak działa płatność?",
        answer:
          "Kupujesz 6-miesięczny Program Budowy Sylwetki Hollywood. Płacisz 6 rat po 622 zł (rabat 450 zł jest rozliczony w ratach). Możesz też wybrać płatność jednorazową (dodatkowe 200 zł rabatu).",
      },
      {
        question: "❓ Co się dzieje po płatności - kiedy startuję?",
        answer:
          "Po przeprowadzeniu płatności otrzymujesz natychmiastowy dostęp do aplikacji i w ciągu 24h roboczych skontaktuje się z Tobą dedykowany dietetyk, aby umówić się na pierwszą konsultację telefoniczną. Otrzymujesz dodatkowe 7 dni w Programie bezpłatnie, aby na spokojnie przygotować się do procesu.",
      },
      {
        question: "❓ Co jeśli będę działać, a efekt nie będzie satysfakcjonujący?",
        answer:
          "Jeśli realizujesz minimum 90% zaleceń i jesteś w stałym kontakcie z dietetykiem, a nie widzisz realnej zmiany sylwetki - prowadzimy Cię dalej bez dopłat, aż efekt będzie widoczny. Dodatkowo masz ustawowe 14 dni na odstąpienie od umowy.",
      },
    ],
  },
};

export const bikiniContinueThankYouProps = {
  eyebrow: "Dziękujemy za zakup",
  title: "Pomyślnie zakupiono produkt - sprawdź swój e-mail",
  description:
    "Na Twoją skrzynkę e-mail wysłaliśmy informacje na temat dokończenia procesu zakupu. Jeżeli nie widzisz wiadomości w głównej skrzynce, sprawdź folder SPAM lub OFERTY.",
  renewalTitle: "Pomyślnie odnowiono dostęp do programu",
  renewalDescription:
    "Dziękujemy za odnowienie dostępu do programu. Zaktualizowane informacje o Twoim dostępie znajdziesz w aplikacji.",
  stepSlug: "thankYou",
};

const landing = bikiniContinueLandingProps;
const checkout = bikiniContinueCheckoutProps;

const seoTitle = "Program Hollywood po Bikini | Kontynuacja metamorfozy";
const seoDescription =
  "Zaczęłaś proces metamorfozy w Bikini. Sprawdź warunki uczestniczki i przejdź do pełnego Programu Hollywood z rabatem 450 zł.";
/** What the coded checkout and thank-you pages show without their own NextSeo (the app default). */
const appDefaultTitle = "Program Hollywood";
const appDefaultOgImage =
  "https://imqwfnfhoivklhutcolk.supabase.co/storage/v1/object/public/shared/cb81bd59-fec3-41de-8ef1-49d680c0c7d3/products/rc-upload-1736085225452-2-rc_upload_1716185358422_4_rc_upload_1704781011252_2_AppIcon_ios_marketing.png";
const seoImage =
  "https://imqwfnfhoivklhutcolk.supabase.co/storage/v1/object/public/shared/cb81bd59-fec3-41de-8ef1-49d680c0c7d3/products/rc-upload-1758784151468-3-rc_upload_1757795955237_6_Group_60.png";

export const bikiniContinueTemplates: LandingTemplate[] = [
  {
    key: "hollywood-bikini-continue-landing",
    name: "Hollywood po Bikini - landing",
    kind: LandingPageKind.Landing,
    sourceRoute: "/oferta/hollywood-bikini-continue/start",
    config: createFunnelPageConfig({
      title: seoTitle,
      description: seoDescription,
      ogImage: seoImage,
      pageName: "hollywood-bikini-continue-landing",
      shell: "landing",
      accentColor: "gold",
      backgroundClassName: "dark:bg-gold-2 bg-sand-1 min-h-screen",
      sections: [
        templateSection("effects", "bikiniContinueLandingEffects", landing.effects),
        templateSection("header", "bikiniContinueHeader", landing.header),
        templateSection("hero", "bikiniContinueHero", landing.hero),
        templateSection("transformations", "bikiniContinueTransformations", landing.transformations),
        templateSection("reviews", "bikiniContinueReviews", landing.reviews),
        templateSection("dlaczego", "bikiniContinueWhy", landing.why),
        templateSection("cta-middle", "bikiniContinueCtaButton", landing.middleCta),
        templateSection("program", "bikiniContinueProgram", landing.program),
        templateSection("porownanie", "bikiniContinueComparison", landing.comparison),
        templateSection("warunki", "bikiniContinueConditions", landing.conditions),
        templateSection("gwarancja", "bikiniContinueGuarantee", landing.guarantee),
        templateSection(checkoutAnchor, "bikiniContinueFinalCta", landing.finalCta),
        templateSection("footer", "bikiniContinueFooter", landing.footer),
      ],
    }),
  },
  {
    key: "hollywood-bikini-continue-checkout",
    name: "Hollywood po Bikini - checkout",
    kind: LandingPageKind.Checkout,
    sourceRoute: "/oferta/hollywood-bikini-continue/checkout",
    config: createFunnelPageConfig({
      title: appDefaultTitle,
      ogImage: appDefaultOgImage,
      pageName: "hollywood-bikini-continue-checkout",
      shell: "embedding",
      accentColor: "gold",
      // The coded wrapper's outer div plus the vertical padding of its inner container.
      backgroundClassName: "font-hanken bg-sand-1 min-h-screen py-8 sm:py-12",
      sections: [
        templateSection("intro", "bikiniContinueCheckoutIntro", checkout.intro),
        templateSection("cena", "bikiniContinueCheckoutPriceSummary", checkout.priceSummary),
        templateSection("co-otrzymujesz", "bikiniContinueCheckoutBenefits", checkout.benefits),
        templateSection("gwarancja", "bikiniContinueCheckoutGuarantee", checkout.guarantee),
        templateSection("platnosc", "bikiniContinueCheckoutPayment", checkout.payment),
        templateSection("faq", "bikiniContinueCheckoutFaq", checkout.faq),
      ],
    }),
  },
  {
    key: "hollywood-bikini-continue-dziekujemy",
    name: "Hollywood po Bikini - podziękowanie",
    kind: LandingPageKind.ThankYou,
    sourceRoute: "/oferta/hollywood-bikini-continue/ty",
    config: createFunnelPageConfig({
      title: appDefaultTitle,
      ogImage: appDefaultOgImage,
      pageName: "hollywood-bikini-continue-ty",
      shell: "embedding",
      accentColor: "gold",
      backgroundClassName: "",
      sections: [templateSection("podziekowanie", "bikiniContinueThankYou", bikiniContinueThankYouProps)],
    }),
  },
];
